<div class="row">
  <div class="col-12" >
  <div class="col-12">
    <div class="row py-1">
      <div class="col-8">
       
      </div>
      <div class="col-4">
        <div class="d-flex flex-row-reverse">
          <div class="px-3">
            <!-- <button type="button" style="
            width: 15vh;" [disabled]="!DisableNextButton" (click)="Next()"class="btn btn-sm bl-btn border">Next</button> -->
          </div>
          
        </div>
        
      </div>
    </div>
  </div>
<div class="col-12" style="height:74vh !important; overflow: auto;">
  <div class="row">
  <div class="col-12 pt-1" *ngFor="let s of QuestionTemplatelist; let i = index" >
    <div class="input-group">
      <div class="input-group-prepend" style="
      width: 35px;
      border: none;
      background: transparent;
  ">
        <div class="input-group-text" style="
        background: transparent;
        border: none;
        
    ">
    <div class="d-flex">
      <input type="radio"  [ngClass]="{'radio-btn-check1': s.Question_Template_Type_Code ==='QTxtATxt', 'radio-btn-check2' : s.Question_Template_Type_Code ==='QTxt&ImgATxt' }"  (click)="templateselection($event)" name="checkboxgroup" [value]="s.Question_Template_ID" [checked]="s.checkedflag" aria-label="Radio button for following text input" style="width: 15px; height:15px">
    </div>
      
    
        
        </div>
      </div>
      <div class="row form-control" style="
      border: none;
  ">
        
        <div class="col-12">
          <div class="d-flex t-row">
            <div class="px-1 template"  [ngClass]="{'borderview1':s.checkedflag===true}" *ngIf="s.Question_Template_Type_Code ==='QTxtATxt'">
              <app-qt1-text (selectedtemplate)="selectedtemplate($event)" [QuestionNo]="i+1"  Question="default" template="{{s.Question_Template_ID}}" ></app-qt1-text>          
            </div>
           
            <div class="px-1 template" [ngClass]="{'borderview1':s.checkedflag===true}" *ngIf="s.Question_Template_Type_Code ==='QTxt&ImgATxt'">
              <app-qt3-text (selectedtemplate)="selectedtemplate($event)" [QuestionNo]="i+1" Question="default" template="{{s.Question_Template_ID}}"></app-qt3-text>          
            </div>
            <!-- <div class="row" *ngIf="nextbuttonflag">
              <div class="col-12">
                <app-question-list (EditQuestion)="EditQuestion($event)" ></app-question-list>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</div>
  <div class="col-12">
    <div class="row py-1">
      <div class="col-12">

        <div class="d-flex justify-content-center">
          <div class="px-3">
            <button type="button" style="
            width: 15vh;" [disabled]="!DisableNextButton" (click)="Next()" class="btn btn-sm bl-btn border">Next</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div hidden class="col-12 pt-2">
    <div class="input-group">
      <div class="input-group-prepend" style="
      width: px;
      border: none;
      background: transparent;
  ">
        <div class="input-group-text" style="
        background: transparent;
        border: none;
    ">
        <input type="radio" aria-label="Radio button for following text input" style="width: 15px; height:15px">
        </div>
      </div>
      <div class="row form-control mr-3">
        <div class="col-12 text-center">
          Templat   
        </div>
        <div class="col-12">
          <div class="d-flex t-row">
            <div class="px-1 template">
              <app-qt1-text></app-qt1-text>          
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div hidden class="col-12 pt-2">
    <div class="input-group">
      <div class="input-group-prepend" style="
      width: 53px;
      border: none;
      background: transparent;
  ">
        <div class="input-group-text" style="
        background: transparent;
        border: none;
    ">
        <input type="radio" aria-label="Radio button for following text input" style="width: 15px; height:15px">
        </div>
      </div>
      <div class="row form-control mr-3">
        <div class="col-12 text-center">
          Template2  
        </div>
        <div class="col-12">
          <div class="d-flex t-row">
            <div class="px-1 template">
              <app-qt2-text></app-qt2-text>          
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div hidden class="col-12 pt-2">
    <div class="input-group">
      <div class="input-group-prepend" style="
      width: 53px;
      border: none;
      background: transparent;
  ">
        <div class="input-group-text" style="
        background: transparent;
        border: none;
    ">
        <input type="radio" aria-label="Radio button for following text input" style="width: 15px; height:15px">
        </div>
      </div>
      <div class="row form-control mr-3">
        <div class="col-12 text-center">
          Template3 
        </div>
        <div class="col-12">
          <div class="d-flex t-row">
            <div class="px-1 template">
              <app-qt3-text></app-qt3-text>          
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

</div>

